<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center" align-v="center">
        <b-col md="2">
          <b-img src="/static/img/tools.png" fluid></b-img>
        </b-col>
        <b-col md="6">
          <div class="clearfix">
            <h4 class="pt-3">En mantenimiento</h4>
            <p class="text-muted">Nuestros sistemas se encontrarán disponibles en las próximas horas</p>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Page404'
}
</script>



// WEBPACK FOOTER //
// src/views/pages/UnderMaintenance.vue